import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTillToLength = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 90,
	viewBox: "0 0 200 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3004_29230",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 200,
		height: 90,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 90,
			fill: "#C4C4C4"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_3004_29230)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M97.8677 40.6125L108.545 40.6125L106.18 38.0508C106.018 37.875 105.927 37.6366 105.927 37.3879C105.927 37.1393 106.018 36.9009 106.18 36.725L106.793 36.061C106.874 35.9736 106.969 35.9042 107.075 35.8569C107.18 35.8096 107.293 35.7852 107.406 35.7852C107.52 35.7852 107.633 35.8096 107.738 35.8569C107.843 35.9042 107.939 35.9736 108.019 36.061L112.904 41.3559C113.066 41.5317 113.157 41.7702 113.157 42.0188C113.157 42.2674 113.066 42.5059 112.904 42.6817L108.017 47.9762C107.936 48.0636 107.841 48.133 107.735 48.1803C107.63 48.2276 107.517 48.252 107.404 48.252C107.29 48.252 107.177 48.2276 107.072 48.1803C106.966 48.133 106.871 48.0636 106.791 47.9762L106.178 47.3122C106.015 47.1363 105.924 46.8979 105.924 46.6493C105.924 46.4006 106.015 46.1622 106.178 45.9864L108.542 43.425L97.8677 43.425C97.6382 43.425 97.4181 43.3263 97.2558 43.1505C97.0935 42.9746 97.0023 42.7362 97.0023 42.4875L97.0023 41.55C97.0023 41.3014 97.0935 41.0629 97.2558 40.8871C97.4181 40.7113 97.6382 40.6125 97.8677 40.6125Z",
				fill: "#F6DCC4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.7253 47.0788L81.7257 29.2453L32.3482 57.0352L32.3478 74.8687L81.7253 47.0788Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.347 57.0351L6.26895 42.9172L6.26821 60.8227L32.3463 74.9405L32.347 57.0351Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.9414 29.0568L56.0108 15.0189L6.42125 42.9973L32.3519 57.0351L81.9414 29.0568Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M191.272 66.7921L191.272 36.7089L175.942 44.8879L175.941 74.9711L191.272 66.7921Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M175.941 44.8876L131.95 21.0724L131.949 51.2769L175.94 75.0922L175.941 44.8876Z",
				fill: "#FDF1E6",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M191.271 36.5217L147.529 12.8414L132.206 21.2075L175.948 44.8878L191.271 36.5217Z",
				fill: "#F6DCC4",
				stroke: "#A35705",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})]
});
export default SvgTillToLength;
